import { Component, OnInit, OnDestroy, Input, ChangeDetectorRef, ViewChild, ElementRef, inject, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators, UntypedFormArray, UntypedFormControl } from '@angular/forms';

import { ByocEpisodeFetchService } from '../../service/fetch.service';
import { Subscription, tap } from 'rxjs';
import { control, array } from '../../../../../utils';

@Component({
    selector: 'app-byoc-episode-step-fetch-questions-new',
    templateUrl: './new.component.html',
    styleUrls: ['./new.component.scss'],
    // eslint-disable-next-line @angular-eslint/prefer-on-push-component-change-detection -- legacy component, migrate to OnPush when touched
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class ByocEpisodeStepGeneralQuestionsNewComponent implements OnInit, OnDestroy {
    private readonly formBuilder = inject(UntypedFormBuilder);
    private readonly changeDetectorRef = inject(ChangeDetectorRef);
    private readonly byocEpisodeFetchService = inject(ByocEpisodeFetchService);
    @ViewChild('box', { static: true })
    box!: ElementRef;

    @Input()
    formArray!: UntypedFormArray;

    form!: UntypedFormGroup;

    readonly control = control;

    private subscriptions: Subscription = new Subscription();

    get answersLimitReached(): boolean {
        return this.answers.length > 9;
    }

    ngOnInit() {
        this.initForm();
    }

    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }

    /**
     * Add Wrong Answer
     */
    addWrongAnswerClick(): void {
        this.addAnswer(false);
        this.byocEpisodeFetchService.updatePs();
    }

    /**
     * Removes Answer
     * @param i index of removed element
     */
    removeAnswerClick(i: number) {
        array(this.form.get('answers')).removeAt(i);
        this.byocEpisodeFetchService.updatePs();
    }

    get answers() {
        return array(this.form.get('answers')).controls;
    }

    cancelClick(): void {
        this.byocEpisodeFetchService.close();
    }

    saveClick(): void {
        if (this.form.invalid) {
            return;
        }
        this.formArray.push(this.form);
        this.byocEpisodeFetchService.close();
    }

    /**
     * Init Form
     */
    private initForm(): void {
        this.form = this.formBuilder.group({
            title: ['', [Validators.required, Validators.pattern(/^(?!\s*$).+/)]],
            answers: this.formBuilder.array([]),
        });
        // add wrong answer
        this.addAnswer(true);
        this.addAnswer(false);
        this.subscriptions.add(
            this.form.valueChanges
                .pipe(
                    tap(() => {
                        this.patchForm();
                    }),
                )
                .subscribe(),
        );
    }

    /**
     * Add Wrong Answer
     * @param correct flag if added answer is the correct one
     */
    private addAnswer(correct: boolean) {
        array(this.form.get('answers')).push(
            new UntypedFormGroup({
                title: new UntypedFormControl('', [Validators.required, Validators.pattern(/^(?!\s*$).+/)]),
                correct: new UntypedFormControl(correct, [Validators.required]),
            }),
        );
        this.changeDetectorRef.detectChanges();
        setTimeout(() => {
            this.byocEpisodeFetchService.updatePsScrollTo(this.box.nativeElement.getBoundingClientRect().top);
        }, 10);
    }

    /**
     * Patches Form
     */
    private patchForm(): void {
        this.form.patchValue(
            {
                title: this.form.value.title.split('<').join('').split('>').join(''),
                answers: this.form.value.answers.map((answer: any) => {
                    answer.title = answer.title.split('<').join('').split('>').join('');
                    return answer;
                }),
            },
            { emitEvent: false },
        );
    }
}
